'use client'

import { useEffect, useRef, useState } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { ChevronDownIcon } from 'lucide-react'

type ClampedReviewTextProps = {
	lessLabel: string
	moreLabel: string
	text: string
}

export const ClampedReviewText = ({
	lessLabel,
	moreLabel,
	text,
}: ClampedReviewTextProps) => {
	const textRef = useRef<HTMLParagraphElement>(null)
	const [isExpanded, setIsExpanded] = useState(false)
	const [isTruncated, setIsTruncated] = useState(false)

	useEffect(() => {
		const element = textRef.current
		if (!element) return

		const updateTruncation = () =>
			setIsTruncated(element.scrollHeight > element.clientHeight)

		updateTruncation()

		const observer = new ResizeObserver(updateTruncation)
		observer.observe(element)

		return () => observer.disconnect()
	}, [text])

	return (
		<>
			<p
				ref={textRef}
				className={cn('text-sm whitespace-pre-line', {
					'line-clamp-3': !isExpanded,
				})}
			>
				{text}
			</p>

			{isTruncated ? (
				<button
					className='text-primary ml-auto flex h-auto self-start p-0 text-sm'
					onClick={() => setIsExpanded((value) => !value)}
					type='button'
				>
					{isExpanded ? lessLabel : moreLabel}
					<ChevronDownIcon
						className={cn('size-4 transition-transform', {
							'rotate-180': isExpanded,
						})}
					/>
				</button>
			) : null}
		</>
	)
}
